import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * TrendUp2 icon
 *
 * @category Business
 */
const TrendUp2 = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M3.215 27.15c-.407.295-.192 1.075.283 1.053h24.386c.453-.023.566.045.803-.045.34-.148.407-.634.181-.928-.452-.464-.17-.814-.237-1.945V10.603c.056-.633-.26-.995-1.052-1.018h-2.002c-.611-.034-1.279.023-1.493.509-.125 1.663.01 15.948-.057 16.899-.023.034-.09.056-.226.067-.283-.056-1.912.181-2.036-.147V15.274c.124-.848-.407-1.221-1.278-1.165-.871.159-3.077-.486-3.303.713-.023 1.154.022 11.379-.023 12.148-.316.204-.825.056-1.402.102-.555-.034-.792.09-.871-.215v-7.341c-.102-1.03.362-1.584-.656-1.968-.645-.09-1.957-.023-2.647-.045-.814-.057-1.199.282-1.267.656-.034 1.515 0 4.547-.011 6.356v1.776c-.023.453.068.69-.136.747-.09.034-.26.034-.486.034-.475-.046-1.21.113-1.618-.125-.136-.724-.022-3.133-.056-4.049 0-.566.045-.871-.17-1.142-.441-.566-1.584-.283-2.285-.351-1.357 0-1.945-.102-2.126.735-.034.792 0 3.292-.012 4.423 0 .305.012.407-.101.509l-.068.068zm3.744-4.354a.9.9 0 0 1 .045.35c0 1.2-.011 2.387-.023 3.586 0 .09 0 .204-.09.26-.057.046-.147.057-.226.057q-.934.051-1.867 0c-.113 0-.237-.011-.294-.09-.045-.057-.045-.136-.045-.204 0-1.188-.011-2.375-.023-3.563 0-.124 0-.26.057-.384.237-.532 1.821-.611 2.341-.181a.4.4 0 0 1 .136.17zm6.73-4.038c.113.136.079.453.09.645-.113 2.115.238 5.327-.147 7.375-.328.43-1.346.294-1.742.248-.248-.045-.305-.18-.35-.373-.012-1.255-.057-5.621.022-7.488.08-.69 1.788-.543 2.059-.452l.068.056zm6.854-3.337c.396.94.08 2.082.181 3.394-.124 2.465.25 5.508-.158 7.86-.498.68-2.41.498-2.251-.565-.023-2.194 0-6.13 0-8.732.034-.6-.102-1.187.181-1.697.294-.497 1.55-.531 1.968-.327l.09.067zm6.855-4.501c.316.248.282.7.294 1.085 0 3.903.102 9.898-.034 13.902.136 1.267-2.5 1.64-2.568.328 0-2.794-.034-11.119.012-14.49-.034-.927 1.39-1.3 2.171-.905l.113.068zm-1.301-6.29.011-.01h-.011v-.272a.54.54 0 0 0-.18-.396.63.63 0 0 0-.408-.158l-3.19.09a.55.55 0 0 0-.543.577c0 .317.272.554.588.554l1.98-.056a27.7 27.7 0 0 1-4.174 3.88 27.4 27.4 0 0 1-12.985 5.293 27 27 0 0 1-3.62.238.56.56 0 0 0-.565.565.56.56 0 0 0 .566.566c1.278 0 2.533-.08 3.766-.25A28.6 28.6 0 0 0 20.85 9.733a29 29 0 0 0 4.174-3.834l.045 1.617c0 .305.26.554.565.554h.023c.317 0 .554-.271.554-.577l-.09-2.873z"
        />
      </svg>
    );
  }
);

TrendUp2.displayName = 'TrendUp2';

export { TrendUp2 };
